import { makeRequest, toCorrectFormDataValue, } from '@/js/libs/api';
import * as Types from './types';
import { encodeBody, fromDateType as fromDate, toDateType as toDate, fromDateTimeType as fromDateTime, toDateTimeUnixType as toDateTime, } from '@/js/libs/api-helpers';
export { fromDate, toDate, fromDateTime, toDateTime };
export const getCampaigns = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-selfbooking/campaigns';
    const pathInternal = '/api/campaigns';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.filter !== undefined) {
        urlParams.append('filter', params.filter.toString());
    }
    if (params.advertiserId !== undefined) {
        urlParams.append('advertiserId', params.advertiserId.toString());
    }
    if (params.status !== undefined) {
        urlParams.append('status', params.status.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaigns.paramsOrder = [{ type: 'parameters' }];
export const createCampaign = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/campaigns';
    const pathInternal = '/api/campaigns';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createCampaign.paramsOrder = [{ type: 'body', paramName: 'form' }];
export const getCampaignById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/campaigns/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/campaigns/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignById.paramsOrder = [{ type: 'parameters' }];
export const updateCampaign = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/campaigns/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/campaigns/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCampaign.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const updateCampaignPaymentDetails = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/campaigns/{id}/payment-details'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/campaigns/{id}/payment-details'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCampaignPaymentDetails.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const runCampaign = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/campaigns/{id}/run'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/campaigns/{id}/run'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
runCampaign.paramsOrder = [{ type: 'parameters' }];
export const cloneCampaign = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/campaigns/{id}/clone'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/campaigns/{id}/clone'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
cloneCampaign.paramsOrder = [{ type: 'parameters' }];
export const addCampaignComment = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.commentId === undefined) {
        throw new Error('Missing required parameter: commentId');
    }
    const path = '/api/ws-selfbooking/campaigns/{id}/comments'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/campaigns/{id}/comments'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.commentId !== undefined) {
        urlParams.append('commentId', params.commentId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
addCampaignComment.paramsOrder = [{ type: 'parameters' }];
export const removeCampaignComment = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.commentId === undefined) {
        throw new Error('Missing required parameter: commentId');
    }
    const path = '/api/ws-selfbooking/campaigns/{id}/comments'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/campaigns/{id}/comments'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.commentId !== undefined) {
        urlParams.append('commentId', params.commentId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
removeCampaignComment.paramsOrder = [{ type: 'parameters' }];
export const getCampaignDeliveryDataPerDay = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/campaigns/{id}/delivery-data-per-day'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/campaigns/{id}/delivery-data-per-day'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignDeliveryDataPerDay.paramsOrder = [{ type: 'parameters' }];
export const getHtmlAttachmentPreview = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/campaigns/{id}/attachment/html'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/campaigns/{id}/attachment/html'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.language !== undefined) {
        urlParams.append('language', params.language.toString());
    }
    const headers = {};
    headers['Accept'] = 'text/html';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'text',
        requestType: 'json',
    });
};
getHtmlAttachmentPreview.paramsOrder = [{ type: 'parameters' }];
export const getCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-selfbooking/campaign-positions';
    const pathInternal = '/api/campaign-positions';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.filter !== undefined) {
        urlParams.append('filter', params.filter.toString());
    }
    if (params.advertiserId !== undefined) {
        urlParams.append('advertiserId', params.advertiserId.toString());
    }
    if (params.includeFailedPayment !== undefined) {
        urlParams.append('includeFailedPayment', params.includeFailedPayment.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignPositions.paramsOrder = [{ type: 'parameters' }];
export const createCampaignPosition = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/campaign-positions';
    const pathInternal = '/api/campaign-positions';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createCampaignPosition.paramsOrder = [{ type: 'body', paramName: 'form' }];
export const getCampaignPositionById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/campaign-positions/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/campaign-positions/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignPositionById.paramsOrder = [{ type: 'parameters' }];
export const updateCampaignPosition = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/campaign-positions/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/campaign-positions/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCampaignPosition.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const updateCampaignPositionStatus = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.status === undefined) {
        throw new Error('Missing required parameter: status');
    }
    const path = '/api/ws-selfbooking/campaign-positions/{id}/status'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/campaign-positions/{id}/status'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.status !== undefined) {
        urlParams.append('status', params.status.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCampaignPositionStatus.paramsOrder = [{ type: 'parameters' }];
export const getCampaignPositionsByCampaignId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-selfbooking/campaign-positions/by-campaign';
    const pathInternal = '/api/campaign-positions/by-campaign';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignId !== undefined) {
        urlParams.append('campaignId', params.campaignId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignPositionsByCampaignId.paramsOrder = [{ type: 'parameters' }];
export const getCampaignPositionsByCreativeId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.creativeId === undefined) {
        throw new Error('Missing required parameter: creativeId');
    }
    const path = '/api/ws-selfbooking/campaign-positions/by-creative';
    const pathInternal = '/api/campaign-positions/by-creative';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.creativeId !== undefined) {
        urlParams.append('creativeId', params.creativeId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignPositionsByCreativeId.paramsOrder = [{ type: 'parameters' }];
export const getCampaignPositionDeliveryDataPerDay = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/campaign-positions/{id}/delivery-data-per-day'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/campaign-positions/{id}/delivery-data-per-day'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignPositionDeliveryDataPerDay.paramsOrder = [{ type: 'parameters' }];
export const getCampaignPositionHistory = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-selfbooking/campaign-positions/history';
    const pathInternal = '/api/campaign-positions/history';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignId !== undefined) {
        urlParams.append('campaignId', params.campaignId.toString());
    }
    if (params.campaignPositionId !== undefined) {
        urlParams.append('campaignPositionId', params.campaignPositionId.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignPositionHistory.paramsOrder = [{ type: 'parameters' }];
export const getCampaignPositionPriceHistory = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-selfbooking/campaign-positions/price-history';
    const pathInternal = '/api/campaign-positions/price-history';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignId !== undefined) {
        urlParams.append('campaignId', params.campaignId.toString());
    }
    if (params.campaignPositionId !== undefined) {
        urlParams.append('campaignPositionId', params.campaignPositionId.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignPositionPriceHistory.paramsOrder = [{ type: 'parameters' }];
export const linkCreativesToCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/campaign-positions/link-creatives';
    const pathInternal = '/api/campaign-positions/link-creatives';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    if (params.overrideExisting !== undefined) {
        urlParams.append('overrideExisting', params.overrideExisting.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
linkCreativesToCampaignPositions.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const getForecastInventory = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/forecast/{campaignId}'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/forecast/{campaignId}'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getForecastInventory.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const getBudgetSuggestion = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-selfbooking/budget-suggestion/{campaignId}'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/budget-suggestion/{campaignId}'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBudgetSuggestion.paramsOrder = [{ type: 'parameters' }];
export const getAdvertisers = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-selfbooking/advertisers';
    const pathInternal = '/api/advertisers';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.filter !== undefined) {
        urlParams.append('filter', params.filter.toString());
    }
    if (params.industryId !== undefined) {
        urlParams.append('industryId', params.industryId.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdvertisers.paramsOrder = [{ type: 'parameters' }];
export const createAdvertiser = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/advertisers';
    const pathInternal = '/api/advertisers';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createAdvertiser.paramsOrder = [{ type: 'body', paramName: 'form' }];
export const getAdvertiserById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/advertisers/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/advertisers/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdvertiserById.paramsOrder = [{ type: 'parameters' }];
export const updateAdvertiser = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/advertisers/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/advertisers/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateAdvertiser.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const updateAdvertiserStatus = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.status === undefined) {
        throw new Error('Missing required parameter: status');
    }
    const path = '/api/ws-selfbooking/advertisers/{id}/status'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/advertisers/{id}/status'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.status !== undefined) {
        urlParams.append('status', params.status.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateAdvertiserStatus.paramsOrder = [{ type: 'parameters' }];
export const getAdvertiserCampaignStat = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/advertisers/{id}/campaign-stat'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/advertisers/{id}/campaign-stat'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdvertiserCampaignStat.paramsOrder = [{ type: 'parameters' }];
export const replaceAdvertiser = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.oldAdvertiserId === undefined) {
        throw new Error('Missing required parameter: oldAdvertiserId');
    }
    if (params.newAdvertiserId === undefined) {
        throw new Error('Missing required parameter: newAdvertiserId');
    }
    const path = '/api/ws-selfbooking/advertisers/replace-id';
    const pathInternal = '/api/advertisers/replace-id';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.oldAdvertiserId !== undefined) {
        urlParams.append('oldAdvertiserId', params.oldAdvertiserId.toString());
    }
    if (params.newAdvertiserId !== undefined) {
        urlParams.append('newAdvertiserId', params.newAdvertiserId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
replaceAdvertiser.paramsOrder = [{ type: 'parameters' }];
export const getIndustries = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-selfbooking/industries';
    const pathInternal = '/api/industries';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.filter !== undefined) {
        urlParams.append('filter', params.filter.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getIndustries.paramsOrder = [{ type: 'parameters' }];
export const getConversionTrackers = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.advertiserId === undefined) {
        throw new Error('Missing required parameter: advertiserId');
    }
    const path = '/api/ws-selfbooking/conversion-trackers';
    const pathInternal = '/api/conversion-trackers';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.advertiserId !== undefined) {
        urlParams.append('advertiserId', params.advertiserId.toString());
    }
    if (params.includeInactive !== undefined) {
        urlParams.append('includeInactive', params.includeInactive.toString());
    }
    if (params.searchQuery !== undefined) {
        urlParams.append('searchQuery', params.searchQuery.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getConversionTrackers.paramsOrder = [{ type: 'parameters' }];
export const createConversionTracker = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.advertiserId === undefined) {
        throw new Error('Missing required parameter: advertiserId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/conversion-trackers';
    const pathInternal = '/api/conversion-trackers';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.advertiserId !== undefined) {
        urlParams.append('advertiserId', params.advertiserId.toString());
    }
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createConversionTracker.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const getConversionTrackerById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/conversion-trackers/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/conversion-trackers/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getConversionTrackerById.paramsOrder = [{ type: 'parameters' }];
export const updateConversionTracker = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/conversion-trackers/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/conversion-trackers/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateConversionTracker.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const updateConversionTrackerActiveState = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.active === undefined) {
        throw new Error('Missing required parameter: active');
    }
    const path = '/api/ws-selfbooking/conversion-trackers/{id}/active'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/conversion-trackers/{id}/active'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.active !== undefined) {
        urlParams.append('active', params.active.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateConversionTrackerActiveState.paramsOrder = [{ type: 'parameters' }];
export const getConversionTrackersByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.trackersIds === undefined) {
        throw new Error('Missing required body: trackersIds');
    }
    const path = '/api/ws-selfbooking/conversion-trackers/by-ids';
    const pathInternal = '/api/conversion-trackers/by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.trackersIds !== undefined) {
        body = params.trackersIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getConversionTrackersByIds.paramsOrder = [{ type: 'body', paramName: 'trackersIds' }];
export const getCreatives = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-selfbooking/creatives';
    const pathInternal = '/api/creatives';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.advertiserId !== undefined) {
        urlParams.append('advertiserId', params.advertiserId.toString());
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    if (params.searchQuery !== undefined) {
        urlParams.append('searchQuery', params.searchQuery.toString());
    }
    if (params.flag !== undefined) {
        urlParams.append('flag', params.flag.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCreatives.paramsOrder = [{ type: 'parameters' }];
export const createCreative = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/creatives';
    const pathInternal = '/api/creatives';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createCreative.paramsOrder = [{ type: 'body', paramName: 'form' }];
export const generateCreativeByUrl = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.languageCode === undefined) {
        throw new Error('Missing required parameter: languageCode');
    }
    if (params.url === undefined) {
        throw new Error('Missing required parameter: url');
    }
    const path = '/api/ws-selfbooking/creatives/generate-by-url';
    const pathInternal = '/api/creatives/generate-by-url';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignId !== undefined) {
        urlParams.append('campaignId', params.campaignId.toString());
    }
    if (params.languageCode !== undefined) {
        urlParams.append('languageCode', params.languageCode.toString());
    }
    if (params.url !== undefined) {
        urlParams.append('url', params.url.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
generateCreativeByUrl.paramsOrder = [{ type: 'parameters' }];
export const cloneCreativeGenerateNewText = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.languageCode === undefined) {
        throw new Error('Missing required parameter: languageCode');
    }
    const path = '/api/ws-selfbooking/creatives/{id}/clone-generate-new-text'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/creatives/{id}/clone-generate-new-text'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.languageCode !== undefined) {
        urlParams.append('languageCode', params.languageCode.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
cloneCreativeGenerateNewText.paramsOrder = [{ type: 'parameters' }];
export const updateCreativeGenerateNewText = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.languageCode === undefined) {
        throw new Error('Missing required parameter: languageCode');
    }
    const path = '/api/ws-selfbooking/creatives/{id}/update-generate-new-text'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/creatives/{id}/update-generate-new-text'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.languageCode !== undefined) {
        urlParams.append('languageCode', params.languageCode.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCreativeGenerateNewText.paramsOrder = [{ type: 'parameters' }];
export const getCreativeById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/creatives/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/creatives/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCreativeById.paramsOrder = [{ type: 'parameters' }];
export const updateCreative = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/creatives/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/creatives/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCreative.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const deleteCreative = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/creatives/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/creatives/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteCreative.paramsOrder = [{ type: 'parameters' }];
export const getCreativePreview = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.creativeId === undefined) {
        throw new Error('Missing required parameter: creativeId');
    }
    const path = '/api/ws-selfbooking/creatives/{creativeId}/preview'.replace('{creativeId}', params.creativeId?.toString());
    const pathInternal = '/api/creatives/{creativeId}/preview'.replace('{creativeId}', params.creativeId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCreativePreview.paramsOrder = [{ type: 'parameters' }];
export const updateCreativesStatus = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.ids === undefined) {
        throw new Error('Missing required body: ids');
    }
    if (params.status === undefined) {
        throw new Error('Missing required parameter: status');
    }
    const path = '/api/ws-selfbooking/creatives/{id}/status';
    const pathInternal = '/api/creatives/{id}/status';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.ids !== undefined) {
        body = params.ids;
    }
    if (params.status !== undefined) {
        urlParams.append('status', params.status.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCreativesStatus.paramsOrder = [{ type: 'body', paramName: 'ids' }, { type: 'parameters' }];
export const approveCreative = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/creatives/{id}/approve'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/creatives/{id}/approve'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
approveCreative.paramsOrder = [{ type: 'parameters' }];
export const rejectCreative = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/creatives/{id}/reject'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/creatives/{id}/reject'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
rejectCreative.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const cloneCreative = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/creatives/{id}/clone'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/creatives/{id}/clone'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
cloneCreative.paramsOrder = [{ type: 'parameters' }];
export const getCreativesByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.ids === undefined) {
        throw new Error('Missing required body: ids');
    }
    const path = '/api/ws-selfbooking/creatives/by-ids';
    const pathInternal = '/api/creatives/by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.ids !== undefined) {
        body = params.ids;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCreativesByIds.paramsOrder = [{ type: 'body', paramName: 'ids' }];
export const createSetupIntent = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-selfbooking/pp/setup-intent';
    const pathInternal = '/api/pp/setup-intent';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createSetupIntent.paramsOrder = [];
export const succeedSetupIntent = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.paymentMethod === undefined) {
        throw new Error('Missing required parameter: paymentMethod');
    }
    const path = '/api/ws-selfbooking/pp/setup-intent';
    const pathInternal = '/api/pp/setup-intent';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.paymentMethod !== undefined) {
        urlParams.append('paymentMethod', params.paymentMethod.toString());
    }
    if (params.isDefault !== undefined) {
        urlParams.append('isDefault', params.isDefault.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
succeedSetupIntent.paramsOrder = [{ type: 'parameters' }];
export const getCreditCards = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-selfbooking/credit-cards';
    const pathInternal = '/api/credit-cards';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCreditCards.paramsOrder = [];
export const deleteCreditCard = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/credit-cards/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/credit-cards/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteCreditCard.paramsOrder = [{ type: 'parameters' }];
export const updateCreditCardAsDefault = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/credit-cards/{id}/set-default'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/credit-cards/{id}/set-default'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCreditCardAsDefault.paramsOrder = [{ type: 'parameters' }];
export const getDocumentsByEntity = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.entityId === undefined) {
        throw new Error('Missing required parameter: entityId');
    }
    if (params.entityType === undefined) {
        throw new Error('Missing required parameter: entityType');
    }
    if (params.documentCategory === undefined) {
        throw new Error('Missing required parameter: documentCategory');
    }
    const path = '/api/ws-selfbooking/documents';
    const pathInternal = '/api/documents';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.entityId !== undefined) {
        urlParams.append('entityId', params.entityId.toString());
    }
    if (params.entityType !== undefined) {
        urlParams.append('entityType', params.entityType.toString());
    }
    if (params.documentCategory !== undefined) {
        urlParams.append('documentCategory', params.documentCategory.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDocumentsByEntity.paramsOrder = [{ type: 'parameters' }];
export const createDocument = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/documents';
    const pathInternal = '/api/documents';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createDocument.paramsOrder = [{ type: 'body', paramName: 'form' }];
export const deleteDocument = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/documents/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/documents/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteDocument.paramsOrder = [{ type: 'parameters' }];
export const downloadDocument = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/documents/{id}/download'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/documents/{id}/download'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
downloadDocument.paramsOrder = [{ type: 'parameters' }];
export const getScreenshotCampaigns = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-selfbooking/screenshot-campaigns';
    const pathInternal = '/api/screenshot-campaigns';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.status !== undefined) {
        urlParams.append('status', params.status.toString());
    }
    if (params.filter !== undefined) {
        urlParams.append('filter', params.filter.toString());
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    if (params.advertiserId !== undefined) {
        urlParams.append('advertiserId', params.advertiserId.toString());
    }
    if (params.dateFrom !== undefined) {
        urlParams.append('dateFrom', params.dateFrom.toString());
    }
    if (params.dateTo !== undefined) {
        urlParams.append('dateTo', params.dateTo.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getScreenshotCampaigns.paramsOrder = [{ type: 'parameters' }];
export const getScreenshotCampaignPositionsCount = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-selfbooking/screenshot-campaigns/positions-count';
    const pathInternal = '/api/screenshot-campaigns/positions-count';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.status !== undefined) {
        urlParams.append('status', params.status.toString());
    }
    if (params.filter !== undefined) {
        urlParams.append('filter', params.filter.toString());
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    if (params.advertiserId !== undefined) {
        urlParams.append('advertiserId', params.advertiserId.toString());
    }
    if (params.dateFrom !== undefined) {
        urlParams.append('dateFrom', params.dateFrom.toString());
    }
    if (params.dateTo !== undefined) {
        urlParams.append('dateTo', params.dateTo.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getScreenshotCampaignPositionsCount.paramsOrder = [{ type: 'parameters' }];
export const getScreenshotsByCampaignId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/screenshot-campaigns/{id}/screenshots';
    const pathInternal = '/api/screenshot-campaigns/{id}/screenshots';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.id !== undefined) {
        urlParams.append('id', params.id.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getScreenshotsByCampaignId.paramsOrder = [{ type: 'parameters' }];
export const getScreenshotsEmailTemplateDto = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-selfbooking/screenshot-campaigns/{campaignId}/email-template'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/screenshot-campaigns/{campaignId}/email-template'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getScreenshotsEmailTemplateDto.paramsOrder = [{ type: 'parameters' }];
export const sendScreenshotsEmail = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-selfbooking/screenshot-campaigns/{campaignId}/send'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/screenshot-campaigns/{campaignId}/send'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
sendScreenshotsEmail.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const hideScreenshotCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignPositionIds === undefined) {
        throw new Error('Missing required body: campaignPositionIds');
    }
    const path = '/api/ws-selfbooking/screenshot-campaigns/hide';
    const pathInternal = '/api/screenshot-campaigns/hide';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignPositionIds !== undefined) {
        body = params.campaignPositionIds;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
hideScreenshotCampaignPositions.paramsOrder = [{ type: 'body', paramName: 'campaignPositionIds' }];
export const unhideScreenshotCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignPositionIds === undefined) {
        throw new Error('Missing required body: campaignPositionIds');
    }
    const path = '/api/ws-selfbooking/screenshot-campaigns/unhide';
    const pathInternal = '/api/screenshot-campaigns/unhide';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignPositionIds !== undefined) {
        body = params.campaignPositionIds;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
unhideScreenshotCampaignPositions.paramsOrder = [{ type: 'body', paramName: 'campaignPositionIds' }];
export const downloadScreenshotsArchive = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/screenshot-campaigns/{id}/download-screenshots'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/screenshot-campaigns/{id}/download-screenshots'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/octet-stream';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: {
            200: 'blob',
            204: 'void',
        },
        requestType: 'json',
    });
};
downloadScreenshotsArchive.paramsOrder = [{ type: 'parameters' }];
export const addCampaignPositionScreenshots = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/campaign-positions/{id}/screenshots'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/campaign-positions/{id}/screenshots'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
addCampaignPositionScreenshots.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const deleteCampaignPositionScreenshots = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/campaign-positions/{id}/screenshots'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/campaign-positions/{id}/screenshots'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteCampaignPositionScreenshots.paramsOrder = [{ type: 'parameters' }];
export const deleteCampaignPositionScreenshotFile = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.fileId === undefined) {
        throw new Error('Missing required parameter: fileId');
    }
    const path = '/api/ws-selfbooking/campaign-positions/{id}/screenshots/{fileId}'
        .replace('{id}', params.id?.toString())
        .replace('{fileId}', params.fileId?.toString());
    const pathInternal = '/api/campaign-positions/{id}/screenshots/{fileId}'
        .replace('{id}', params.id?.toString())
        .replace('{fileId}', params.fileId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteCampaignPositionScreenshotFile.paramsOrder = [{ type: 'parameters' }];
export const downloadScreenshot = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.fileId === undefined) {
        throw new Error('Missing required parameter: fileId');
    }
    const path = '/api/ws-selfbooking/screenshots/download';
    const pathInternal = '/api/screenshots/download';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.fileId !== undefined) {
        urlParams.append('fileId', params.fileId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/octet-stream';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'blob',
        requestType: 'json',
    });
};
downloadScreenshot.paramsOrder = [{ type: 'parameters' }];
export const getPaymentsByCampaign = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-selfbooking/payments/by-campaign';
    const pathInternal = '/api/payments/by-campaign';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignId !== undefined) {
        urlParams.append('campaignId', params.campaignId.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPaymentsByCampaign.paramsOrder = [{ type: 'parameters' }];
export const getPayouts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-selfbooking/payouts';
    const pathInternal = '/api/payouts';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.dateFrom !== undefined) {
        urlParams.append('dateFrom', params.dateFrom.toString());
    }
    if (params.dateTo !== undefined) {
        urlParams.append('dateTo', params.dateTo.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPayouts.paramsOrder = [{ type: 'parameters' }];
export const downloadPayoutsArchive = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/payouts/{id}/archive'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/payouts/{id}/archive'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
downloadPayoutsArchive.paramsOrder = [{ type: 'parameters' }];
export const getInvoices = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-selfbooking/invoices';
    const pathInternal = '/api/invoices';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.state !== undefined) {
        urlParams.append('state', params.state.toString());
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    if (params.searchQuery !== undefined) {
        urlParams.append('searchQuery', params.searchQuery.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getInvoices.paramsOrder = [{ type: 'parameters' }];
export const generateInvoiceDocument = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-selfbooking/invoices/{id}/generate'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/invoices/{id}/generate'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
generateInvoiceDocument.paramsOrder = [{ type: 'parameters' }];
export const updateInvoiceState = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.state === undefined) {
        throw new Error('Missing required parameter: state');
    }
    const path = '/api/ws-selfbooking/invoices/{id}/state'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/invoices/{id}/state'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.state !== undefined) {
        urlParams.append('state', params.state.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
updateInvoiceState.paramsOrder = [{ type: 'parameters' }];
export const getBalance = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-selfbooking/balances/current';
    const pathInternal = '/api/balances/current';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBalance.paramsOrder = [];
export const topUpBalance = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/balances/top-up';
    const pathInternal = '/api/balances/top-up';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
topUpBalance.paramsOrder = [{ type: 'body', paramName: 'form' }];
export const chargeBalance = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-selfbooking/balances/charge';
    const pathInternal = '/api/balances/charge';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
chargeBalance.paramsOrder = [{ type: 'body', paramName: 'form' }];
export const getBalanceHistory = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, ...otherParams }) => {
    const path = '/api/ws-selfbooking/balance-history';
    const pathInternal = '/api/balance-history';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBalanceHistory.paramsOrder = [{ type: 'parameters' }];
export * from './types';
export * from './constants';
